
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie';

@Injectable()
export class PromotionsService {
  private promocodeStorageKey = 'sc-activated-promocode';
  private baseUrl = environment.API;

  constructor(
    private http: HttpClient,
    private cookies: CookieService
  ) {}

  load(location) {
    const url = `${this.baseUrl}/discounts/promoted/?environment=web&location=${location}`;

    return this.http.get(url).pipe(map((response: any) => {
      return response.results;
    }));
  }

  activate(promocode) {
    this.cookies.put(this.promocodeStorageKey, promocode);
  }

  clear() {
    this.cookies.remove(this.promocodeStorageKey);
  }

  getActive() {
    return this.cookies.get(this.promocodeStorageKey);
  }
}
